/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const SubstantiveEvaluation = {

	delete (context, substantiveEvaluationId, onSuccess, onError, options) {
		Api.delete(context,
			"/substantive-evaluation"
			+ "?substantiveEvaluationId=" + substantiveEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	get (context, substantiveEvaluationId, onSuccess, onError, options) {
		Api.get(context,
			"/substantive-evaluation"
			+ "?substantiveEvaluationId=" + substantiveEvaluationId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getConfiguration (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/substantive-evaluation/configuration"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getContestNames (context, onSuccess, onError, options) {
		Api.get(context,
			"/substantive-evaluation/contest-names"
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postCommitteeUsers (context, offerId, committeeUserIds, onSuccess, onError, options) {
		Api.post(context,
			"/substantive-evaluation/committee-users"
			+ "?offerId=" + offerId
			, committeeUserIds
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	put (context, substantiveEvaluationId, onSuccess, onError, options) {
		Api.put(context,
			"/substantive-evaluation"
			+ "?substantiveEvaluationId=" + substantiveEvaluationId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCorrection (context, evaluationId, correctionCauseDTO, onSuccess, onError, options) {
		Api.put(context,
			"/substantive-evaluation/correction"
			+ "?evaluationId=" + evaluationId
			, correctionCauseDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putData (context, substantiveEvaluationId, substantiveEvaluationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/substantive-evaluation/data"
			+ "?substantiveEvaluationId=" + substantiveEvaluationId
			, substantiveEvaluationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, substantiveEvaluationId, substantiveEvaluationDTO, onSuccess, onError, options) {
		Api.put(context,
			"/substantive-evaluation/finish"
			+ "?substantiveEvaluationId=" + substantiveEvaluationId
			, substantiveEvaluationDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
